export default "__VITE_ASSET__BAB2uMt5__"